import { routerReducer } from 'react-router-redux'
import { combineReducers } from 'redux'
import { createResponsiveStateReducer } from 'redux-responsive'

import core from './core'
import paused from '../../client/reducers/paused'
import waiting from '../../client/reducers/waiting'
import coach from '../../client/reducers/coach'

export default combineReducers({
  browser: createResponsiveStateReducer({
    extraSmall: 575,
    small: 768,
    medium: 991,
    large: 1199
  }),
  core,
  coach,
  paused,
  waiting,
  routing: routerReducer
})
